/**
 * Geliştirme ortamı hata günlükleyici.
 * Üretimde (production build) konsola hiçbir şey yazmaz — hata ayıklama
 * bilgilerinin son kullanıcıya sızmasını engeller.
 */
export const logError = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.error(...args);
  }
};
